import {
  onboardingCategories,
  onboardingTopicContentTypes,
  onboardingWalkthroughs,
} from '@/constants/onboardingChecklist';

const titleCase = (slug) =>
  slug
    .split('-')
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');

/**
 * `categoryId` is read once, not reactively — both call sites (`Tutorials/Panel.vue`,
 * `GetStarted/Widget.vue`) swap views with v-if/v-else, which remounts
 *
 * isAvailable checks content type, and for static-modal topics that slides exist
 */
export const useOnboardingTopics = (categoryId) => {
  const category = onboardingCategories.find((candidate) => candidate.id === categoryId);

  const topics = (category?.topicIds ?? []).map((topicId) => {
    const topic = onboardingWalkthroughs.find((candidate) => candidate.id === topicId);
    // A static-modal topic is only available once its slides are authored; a walkthrough's
    // availability still rides on content type alone, unchanged.
    const isAvailable =
      onboardingTopicContentTypes[topicId] === 'walkthrough' || Boolean(topic?.slides?.length);

    return {
      id: topicId,
      name: topic?.name ?? titleCase(topicId),
      description: topic?.description ?? '',
      infoText: topic?.infoText ?? '',
      isAvailable,
    };
  });

  return { category, topics };
};
